export default "__VITE_ASSET__tsLy9lWJ__"